<script lang="ts">
	import { twMerge } from "tailwind-merge";
	import { Mode } from "#gen/bundles/v1/service_pb.js";
	import Module from "#lib/components/flow/viewer/desktop/Module.svelte";
	import type { AppSwitcherProps } from "#lib/components/flow/viewer/types.js";

	const { page, metadata, readOnly = false, interpolate = false, mode = Mode.LIVE, layoutName, themeStyle, classes, isLightBackground, onExecute, onCancel, onShow, onEdit }: AppSwitcherProps = $props();
	const inlineClass = $derived(twMerge("w-full rounded-2xl bg-white p-3 text-gray-900", classes.borderClass, classes.outlineClass, classes.readOnlyClass));
</script>

<div class="w-full">
	<Module module={page} {metadata} {mode} {themeStyle} {isLightBackground} {readOnly} {interpolate} {layoutName} {onExecute} {onCancel} {onShow} {onEdit} classes={{ ...classes, inlineClass }} isDesktop={true} />
</div>
